import { createStore, applyMiddleware, compose } from "redux";
// import logger from "redux-logger";
import thunk from "redux-thunk";
import rootReducer from "./reducers/rootReducer";
import { loadState, saveState } from "./localStorage";
let throttle = require("lodash.throttle");

const persistedState = loadState();
const middlewares = [thunk];

export const store = createStore(
  rootReducer,
  persistedState,
  compose(applyMiddleware(...middlewares))
);

store.subscribe(
  throttle(() => {
    saveState(store.getState());
  }, 1000)
);
